// FirebaseUI Auth: Refer <https://www.apps-gcp.com/firebase-authentication/>
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedValueService } from './sharedValue.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { FirebaseUISignInSuccessWithAuthResult, FirebaseUISignInFailure } from 'firebaseui-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [AngularFireAuth],
})

export class AppComponent implements OnInit {

  logo: string = 'assets/logomessage.png';
  strNoIcon: string = 'assets/iconSnowman.png';
  iconSnowman2: string = 'assets/mascot2.gif';
  public user: Observable<firebase.User>;
  //isLogin: boolean;
  isLoginButtons: string = "disabled";
  isLoggedIn = false;                //ログインしているか。

  // Angular認証 で　ログイン
  constructor(public afAuth: AngularFireAuth, private sharedValue: SharedValueService) {
    this.user = afAuth.authState;
    this.user.subscribe();
  }

  ngOnInit(){
    this.afAuth.auth.onAuthStateChanged(user => {
      if(user) {
        console.log("KANO:ログインしたよ(ngOnInit)");
        this.sharedValue.isLoggedIn = true;
        this.sharedValue.strUid = user.uid;
        this.sharedValue.strEmail = user.email;
        if(user.displayName==null) {
          this.sharedValue.strLoginUser = user.email.substr(0,user.email.indexOf('@'));
        } else {
          this.sharedValue.strLoginUser = user.displayName;
        }
      }
    });
  }

  showButtons() {
    this.isLoginButtons = "enabled";
  }
  hideButtons() {
    this.isLoginButtons = "disabled";
  }

  logout() {
      this.isLoginButtons = "disabled";
      this.sharedValue.strLoginUser = "";
      this.sharedValue.isLoggedIn = false;
      this.sharedValue.strUid = "";
      this.sharedValue.strEmail = "";
      this.afAuth.auth.signOut().then(function() {                   // 認証オブジェクトからログアウトした
        console.log("KANO: ログアウト成功 in logout()")
      }).catch(function(error) {
        console.log("KANO: ログアウト失敗 in logout("+error+") 何故？");
    });
  }

  // 成功時のコールバック
  successCallback(signInSuccessData: FirebaseUISignInSuccessWithAuthResult) {
    console.log("KANO: ログイン成功 UserID("+signInSuccessData.authResult.user.uid+")");
    }

  // 失敗時のコールバック
  async errorCallback(errorData: FirebaseUISignInFailure) {
    console.log("KANO: ログイン失敗("+errorData+")" );
  }

  get strLoginUserName() { return `${this.sharedValue.strLoginUser}`; }

}
